import useSubmitButtonName from 'hooks/forms/useSubmitButtonName';
import useSubmit from 'hooks/forms/useSubmitForm';
import { message } from 'antd';
import I18n from 'i18n-js';
import { tickets_path } from 'js-routes/generated/routes';
import buildFormParams from '../helpers/buildFormParams';

const useSubmitForm = ({
  id,
  form,
  formUrl,
  clearErrors,
  handleError,
  setIsModalOpen,
  setSelectedNode,
  setInitialTickets,
  ticketFromDashboard,
  attachments,
  setAttachments,
  externalLinks,
  resetAssigneeChoice = () => {},
}) => {
  const { handleSubmitForm, isFormSending } = useSubmit({
    formUrl,
    handleError,
    objectId: id,
    beforeSubmitForm: clearErrors,
    buildFormParams: () => (buildFormParams({ form, attachments, externalLinks })),
    afterSuccessSubmitForm: ({ data }) => {
      form.resetFields();
      resetAssigneeChoice();
      setAttachments([]);
      setIsModalOpen(false);
      setSelectedNode(null);
      if (ticketFromDashboard) {
        // editing puts the ticket id in the URL; restore the index URL when the modal closes
        if (id) {
          globalThis.history.replaceState({}, '', tickets_path());
        }
        setInitialTickets(data.filteredTickets);
      } else {
        globalThis.location.href = data.redirectUrl;
      }

      message.success(I18n.t(id ? 'flash.tickets.updated' : 'flash.tickets.created'));
    },
  });

  const handleSubmitWrapper = (formData) => {
    clearErrors();
    handleSubmitForm(formData);
  };

  const submitButtonName = useSubmitButtonName({
    objectId: id,
    isFormSending,
    modelName: 'ticket',
  });

  return {
    isFormSending,
    submitButtonName,
    handleSubmitForm: handleSubmitWrapper,
  };
};

export default useSubmitForm;
